<section class="playground">
  <h2 class="playground__heading">Reservation review card</h2>
  <p class="playground__hint">
    <code>common-reservation-review-card</code> — tarjeta compuesta: avatar + nombre + unidad + fecha + descripción.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>userName</span>
        <input type="text" [(ngModel)]="data.userName" />
      </label>

      <label class="playground__field">
        <span>avatarUrl (opcional)</span>
        <input type="text" [(ngModel)]="data.avatarUrl" placeholder="https://..." />
      </label>

      <label class="playground__field">
        <span>avatarInitials (fallback)</span>
        <input type="text" [(ngModel)]="data.avatarInitials" maxlength="2" />
      </label>

      <label class="playground__field">
        <span>unitName</span>
        <input type="text" [(ngModel)]="data.unitName" />
      </label>

      <label class="playground__field">
        <span>date</span>
        <input type="text" [(ngModel)]="data.date" />
      </label>

      <label class="playground__field">
        <span>description</span>
        <input type="text" [(ngModel)]="data.description" />
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-reservation-review-card [data]="data"></common-reservation-review-card>
      </div>
    </div>
  </div>
</section>
